var map = {
	"./ab-icon.png": 2112,
	"./ab-icon.webp": 2113,
	"./ag-icon.png": 2114,
	"./ag-icon.webp": 2115,
	"./dg-icon.png": 2116,
	"./dg-icon.webp": 2117,
	"./ea-icon.png": 2118,
	"./ea-icon.webp": 2119,
	"./evo-icon.png": 2120,
	"./evo-icon.webp": 2121,
	"./gpi-icon.png": 2122,
	"./gpi-icon.webp": 2123,
	"./isb-icon.png": 2124,
	"./isb-icon.webp": 2125,
	"./mg-icon.png": 2126,
	"./mg-icon.webp": 2127,
	"./net-icon.png": 2128,
	"./net-icon.webp": 2129,
	"./pg-icon.webp": 2130,
	"./png-icon.png": 2131,
	"./png-icon.webp": 2132,
	"./pp-icon.png": 2133,
	"./pp-icon.webp": 2134,
	"./pt-icon.png": 2135,
	"./pt-icon.webp": 2136,
	"./qs-icon.png": 2137,
	"./qs-icon.webp": 2138,
	"./qt-icon.png": 2139,
	"./qt-icon.webp": 2140,
	"./sa-icon.png": 2141,
	"./sa-icon.webp": 2142,
	"./sb-icon.png": 2143,
	"./sb-icon.webp": 2144,
	"./sbo-icon.png": 2145,
	"./sbo-icon.webp": 2146,
	"./sg-icon.png": 2147,
	"./sg-icon.webp": 2148,
	"./sp-icon.png": 2149,
	"./sp-icon.webp": 2150,
	"./ttg-icon.png": 2151,
	"./ttg-icon.webp": 2152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2111;